import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const CART_KEY = 'uidesign_cart';
const CartContext = createContext(null);

function loadCart() {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY) || '[]');
  } catch { return []; }
}

function saveCart(items) {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(loadCart);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [checkoutNow, setCheckoutNow] = useState(false);

  useEffect(() => { saveCart(items); }, [items]);

  const addItem = useCallback((item, goToCheckout = false) => {
    const id = `${item.product_slug}-${Date.now()}`;
    setItems(prev => [...prev, { ...item, id, qty: item.qty || 1, addedAt: new Date().toISOString() }]);
    setCheckoutNow(goToCheckout);
    setDrawerOpen(true);
  }, []);

  const removeItem = useCallback((id) => {
    setItems(prev => prev.filter(i => i.id !== id));
  }, []);

  const updateQuantity = useCallback((id, qty) => {
    if (qty < 1) return;
    setItems(prev => prev.map(i => i.id === id ? { ...i, qty } : i));
  }, []);

  const clearCart = useCallback(() => { setItems([]); }, []);

  const total = items.reduce((sum, i) => sum + (i.totalPrice || 0) * (i.qty || 1), 0);
  const count = items.reduce((sum, i) => sum + (i.qty || 1), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQuantity, clearCart, total, count, drawerOpen, setDrawerOpen, checkoutNow, setCheckoutNow }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be within CartProvider');
  return ctx;
}
